"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapJsonResponsePassthrough = exports.mapJsonResponse = void 0;

var _AjaxObservable = require("rxjs/observable/dom/AjaxObservable");

var mapJsonResponse = function mapJsonResponse(ajaxResponse) {
  if (ajaxResponse.status !== 204 && (ajaxResponse.response === undefined || ajaxResponse.response === null)) {
    throw new _AjaxObservable.AjaxError('Response is required', ajaxResponse.xhr, ajaxResponse.request);
  }

  return ajaxResponse.response;
};

exports.mapJsonResponse = mapJsonResponse;

var mapJsonResponsePassthrough = function mapJsonResponsePassthrough(ajaxResponse) {
  return ajaxResponse.response;
};

exports.mapJsonResponsePassthrough = mapJsonResponsePassthrough;